import { SVGProps } from 'react';
import { DetailedHTMLProps, ImgHTMLAttributes } from 'react';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

interface ImgIconProps extends DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
  className?: string;
}

export function NetworkAvaxIcon({ className, ...props }: ImgIconProps) {
  return (
    <img 
      src="/Crypto Logos/AVAX.png" 
      alt="Avalanche" 
      className={className} 
      {...props}
    />
  );
}

export function NetworkBNBIcon({ className, ...props }: ImgIconProps) {
  return (
    <img 
      src="/Crypto Logos/BNB_chain.png" 
      alt="BNB Chain" 
      className={className} 
      {...props}
    />
  );
}

export function NetworkBSCTestnetIcon({ className, ...props }: ImgIconProps) {
  return (
    <img 
      src="/Crypto Logos/BSC Testnet.png" 
      alt="BSC Testnet" 
      className={className} 
      {...props}
    />
  );
}

export function NetworkETHIcon({ className, ...props }: ImgIconProps) {
  return (
    <img 
      src="/Crypto Logos/ETH.png" 
      alt="Ethereum" 
      className={className} 
      {...props}
    />
  );
}

export function NetworkAbstractIcon({ className, ...props }: ImgIconProps) {
  return (
    <img 
      src="/Crypto Logos/Abstract-logo.png" 
      alt="Abstract" 
      className={`rounded-full object-cover ${className}`} 
      {...props}
    />
  );
}

export function NetworkPolygonIcon({ className, ...props }: ImgIconProps) {
  return (
    <img 
      src="/Crypto Logos/Polygon_zkEVM_new.png" 
      alt="Polygon" 
      className={className} 
      {...props}
    />
  );
}
